<div class="EXTRA_SERVICE_REMOVAL_FORM modal-header w-100 d-inline-block border-bottom pb-0 mb-0">
    <div class="d-flex justify-content-between">
      <h4 class="booking-modal-title">Removal Service</h4>
      <p class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</p>
    </div>
    <div>
    </div>
  </div>
  <div class="modal-body p-4 mt-3">
   <p class="my-3 intro">Our team are available on the go to assist & support with your Removal Service request.</p>
    <form [formGroup]="form">
        
        <div class="col-12 form-input mb-3">
            <label class="mt-2 form-label ">
             Location of item <span class="text-danger">*</span>
            </label>
            <app-location-selector className="input-locator" placeholder="Enter location of items that needs to be removed" [showErrorMsg]="false"
            [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
            (values)="locationChangeF($event)">
          </app-location-selector>
        </div>
      
        <div class="col-12 form-input mb-3">
            <label class="mt-2 form-label ">
             Destination of item <span class="text-danger">*</span>
            </label>
            <app-location-selector className="input-locator" placeholder="Enter location of items that needs to be delivered" [showErrorMsg]="false"
            [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
            (values)="locationChangeT($event)">
          </app-location-selector>
        </div>
      
        <div class="col-12 form-input mb-3">
            <app-input-list-group [lists]="form.value.item_types" [formData]="otherFacilitiesData.form"
            [formGrp]="form" formCtrlName="item_types" (removedElement)="getRemovedRule($event)" ></app-input-list-group>
  
  
        </div>
      
        <div class="mb-3 ">
           
            <label class="mt-2 form-label ">
                Packing and Transportation Arrangements <span class="text-danger">*</span>
            </label>
            <textarea formControlName="packing_and_transportation_arrangements" 
            placeholder="State if packing and transportation arrangements are needed " 
            class="form-control form-input booking-text-area text-body"
              cols="10" rows="5"></textarea>
        
            
        </div>
        <div class="mb-3 ">
           
            <label class="mt-2 form-label form-toggle">
              Additional Request
            </label>
            <textarea formControlName="additional_requests" 
            placeholder="Any special requests or preferences, such as handling fragile items or insurance coverage for the items" 
            class="form-control form-input booking-text-area text-body"
              cols="10" rows="5"></textarea>
        
            
        </div>
        <app-button 
                    class="book-btn"
                    [disabled]="form.invalid"
                    (click)="submit()"
                    [className]="'w-100'" warning>
                    {{loading ? 'Loading...': 'Submit'}}
                  </app-button>
    </form>


  </div>
  